<template>
	<div>
		<div class="container">
			<div class="infoContain">
				<div>
					<div class="article">
						<div class="article-title mt-5">
							<h3>학력</h3>
						</div>

						<div class="flex mobileFlex customRow">
							<ValidationProvider
								class="inputBox infoBox"
								name="시도"
								rules="required"
								v-slot="{ errors }"
							>
								<label>최종학력</label>
								<div class="bspSelectBox">
									<b-form-select v-model="signupInfo.education" :options="sidoList">
									</b-form-select>
								</div>
								<span class="notValidationTxt">{{ errors[0] }}</span>
							</ValidationProvider>
							<div class="inputBox infoBox">
								<label>최종학교명</label>
								<input
									v-model="signupInfo.school"
									placeholder="최종 학교명을 입력하세요."
									type="text"
									class="input-grey"
								/>
							</div>
						</div>

						<h4 class="fs24 mt-4" style="margin-bottom: 1rem;">
							경력 정보
						</h4>

						<template v-if="signupInfo.careers && signupInfo.careers.length > 0">
							<div
								v-for="(item, index) in signupInfo.careers"
								:key="index"
								class="rowTime inputBox infoBox"
							>
								<div class="flex mobileFlex flexAlignC">
									<div>
										<label v-if="index === 0" for="" class="inputBox__label">기간</label>
										<div class="flex flexAlignC">
											<div class="rowTime__stt">
												<i class="ic ic--arrow-down"></i>
											</div>
											<div class="rowTime__time">
												<div class="flex flexAlignC">
													<date-picker
														class="input-grey"
														v-model="signupInfo.careers[index].careerPeriodFrom"
														:config="optionsDate"
													></date-picker>
													<i class="ic ic--line"></i>
													<date-picker
														class="input-grey"
														v-model="signupInfo.careers[index].careerPeriodTo"
														:config="optionsDate"
													></date-picker>
												</div>
											</div>
										</div>
									</div>
									<div class="rowTime__input">
										<label v-if="index === 0" for="" class="inputBox__label">경력 사항</label>
										<div class="flex flexAlignC">
											<input
												v-model="signupInfo.careers[index].name"
												placeholder="최종 학교명을 입력하세요."
												type="text"
												class="input-grey"
											/>
											<div class="checkBoxItem">
												<div class="flex flexAlignC"></div>
												<input
													v-model="signupInfo.careers[index].inOffice"
													:id="'careersinOffice' + index"
													type="checkbox"
													value="1"
												/>
												<label :for="'careersinOffice' + index" style="white-space: nowrap">
													재직중
												</label>
											</div>
											<div class="rowTime__input">
												<button
													v-if="index != 0"
													type="button"
													class="btn-icon btn-gray"
													@click.prevent="removeRowDate(index)"
												>
													<i class="ic ic--minus-white"></i>
												</button>
												<button v-else type="button" class="btn-icon" @click.prevent="addRowDate">
													<i class="ic ic--plus"></i>
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>
					</div>

					<div class="article">
						<div class="middle-title">
							<h4 class="fs24">자기소개</h4>
						</div>

						<div class="inputBox infoBox">
							<label>나의 소개</label>
							<textarea
								class="input-grey"
								v-model="signupInfo.aboutMe"
								placeholder="나에 대한 간략한 소개를 입력하세요."
							></textarea>
						</div>
					</div>

					<div class="article" style="margin-bottom: 4rem !important;">
						<div class="article-title">
							<h4>매치메이킹 희망분야</h4>
						</div>

						<template v-if="userActivity && userActivity.length > 0">
							<div v-for="(item, index) in userActivity" :key="'useruserActivity_' + index">
								<div class="article-explain">
									<h5>
										{{ item.text }}
									</h5>
								</div>

								<div class="flex mobileFlex mt-4" style="gap: 2rem;">
									<div
										v-for="(subItem, index2) in item.sub"
										:key="index2"
										class="checked-sectors-name-btn"
									>
										<h5>{{ subItem.text }}</h5>
									</div>
								</div>
							</div>
						</template>
					</div>
					<div class="flex flexAlignC pa-2">
						<button type="button" class="btn-outlined" @click="handleShowFieldOfMatchmaking">
							<span style="margin-right: 1rem">정보 수정 </span>
							<i class="ic ic--chevron-up" :class="{ down: isShowFieldOfMatchmaking }"></i>
						</button>
					</div>

					<div v-if="isShowFieldOfMatchmaking" class="article mt-4">
						<div class="article-explain">
							<h5>
								진행 중인 대표 사업을 선택 후, 해당되는 항목을 선택해 주세요.
							</h5>
						</div>
						<div class="flex mobileFlex">
							<div class="select-content">
								<div v-for="(industry, index) in age_friendly_industry" :key="industry.value">
									<div class="checkBoxItem">
										<input
											v-model="industry.isChecked"
											type="checkbox"
											:id="'industryCheckbox' + industry.value + '_' + index"
											:value="industry.value"
										/>
										<label :for="'industryCheckbox' + industry.value + '_' + index">
											고령친화{{ industry.name }}
										</label>
									</div>
									<template v-if="industry.isChecked">
										<div class="">
											<SelectMultipleOption
												v-model="industry.categoryIds"
												:options="industry.sectors"
												placeholder="업종을 선택해주세요."
											>
											</SelectMultipleOption>
										</div>
									</template>
								</div>
							</div>
						</div>
					</div>
					<div>
						<div class="article" style="margin-bottom: 4rem !important;">
							<div class="article-title">
								<h4>매치메이킹 희망활동</h4>
							</div>

							<template v-if="userActivity && userActivity.length > 0">
								<div v-for="(item, index) in userActivity" :key="'userActivity_' + index">
									<div class="article-explain">
										<h5>
											{{ item.text }}
										</h5>
									</div>

									<div class="flex mobileFlex mt-4">
										<div class="checked-sectors-name-btn">
											<h5>
												{{ item.content }}
											</h5>
										</div>
									</div>
								</div>
							</template>
						</div>
						<div class="flex flexAlignC pa-2">
							<button
								type="button"
								class="btn-outlined"
								@click="handleShowMatchmakingHopeActivities"
							>
								<span style="margin-right: 1rem">정보 수정 </span>
								<i class="ic ic--chevron-up" :class="{ down: isShowMatchmakingHopeActivities }"></i>
							</button>
						</div>
					</div>

					<div v-if="isShowMatchmakingHopeActivities" class="article">
						<div class="article-title">
							<h4>매치메이킹 희망활동</h4>
						</div>
						<div class="article-explain">
							<h5>
								매치메이킹을 통해 도움받고자 하는 항목을 선택 후, 구체적인 내용을
								적어주십시오.(복수선택 가능)
							</h5>
						</div>
						<div class="flex mobileFlex">
							<div class="select-content">
								<div v-for="(activity, index) in hope_activity" :key="index">
									<div class="checkBoxItem">
										<input
											v-model="activity.isChecked"
											type="checkbox"
											:id="'activityCheckbox' + activity.value + '_' + index"
											:value="activity.value"
										/>
										<label :for="'activityCheckbox' + activity.value + '_' + index">
											{{ activity.name }}
										</label>
									</div>
									<div v-if="activity.isChecked" class="inputBox mt-3">
										<input
											v-model="activity.content"
											placeholder="도움 받고자 하는 내용을 구체적으로 입력하세요."
											type="text"
											class="input-grey"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import * as eventUtil from '@/utils/eventUtil'
import { ageFriendlyIndustry, hopeActivity, sidoList } from '@/data/constances'
import { mapState } from 'vuex'
import SelectMultipleOption from '@/components/formControl/SelectMultipleOption.vue'

export default {
	components: {
		ValidationProvider,
		SelectMultipleOption,
	},
	props: {
		form: {
			type: Object,
			required: true,
			default() {
				return {}
			},
		},
	},
	data() {
		let propsForm = this.form
		return {
			isShowFieldOfMatchmaking: false,
			isShowMatchmakingHopeActivities: false,
			message: '',
			selectedSido: '',
			date: new Date(),
			sidoList: [
				{value: null, text: '최종학력을 선택하세요.'},
				{value: '0', text: '고졸 이하'},
				{value: '1', text: '대학교 졸'},
				{value: '2', text: '대학원 석사 이상'},
			],
			optionsDate: {
				format: 'DD/MM/YYYY',
				useCurrent: false,
			},
			eventUtil: eventUtil,
			signupInfo: this.form,
			age_friendly_industry: ageFriendlyIndustry.map((item) => {
				let isChecked = propsForm.industries1?.some((ind) => ind.categoryIndustryId == item.value)
				let categoryIds =
					propsForm.industries1?.find((ind) => ind.categoryIndustryId == item.value)?.categoryIds ||
					[]

				return {
					...item,
					isChecked,
					categoryIds,
					selected: item.sectors.filter((ind) => categoryIds.includes(ind.value)),
					categoryIndustryId: item.value,
				}
			}),
			hope_activity: hopeActivity.map((item = {}) => {
				let activity = propsForm.activities?.find((ind) => ind.activityId === item.value)

				return {
					...item,
					activityId: activity?.activityId || item.value,
					content: activity?.content || '',
					isChecked: propsForm.activities?.some((ind) => ind.activityId === item.value),
				}
			}),
		}
	},
	computed: {
		...mapState('auth', ['user']),
		formData() {
			return {
				education: this.signupInfo?.education,
				school: this.signupInfo?.school,
				careers: this.signupInfo?.careers,
				aboutMe: this.signupInfo?.aboutMe,
				activities: this.selectedActivity,
				industries1: this.selectedIndustry,
			}
		},
		selectedIndustry() {
			return this.age_friendly_industry
				.filter((item) => item.isChecked)
				.map((item) => ({
					categoryIds: item.categoryIds,
					categoryIndustryId: item.value,
				}))
		},
		selectedActivity() {
			return this.hope_activity
				.filter((item) => item.isChecked)
				.map((item) => ({
					activityId: item.value,
					content: item.content,
				}))
		},
		userActivity() {
			return (
				this.user?.activities
					?.map((activity) => {
						let item = hopeActivity.find((a) => a.value == activity.activityId)
						if (!item) return null
						return {
							...activity,
							text: item.name,
						}
					})
					?.filter((item) => item !== null) || []
			)
		},
		userIndustry() {
			return (
				this.user?.industries1
					?.map((item) => {
						let obj = ageFriendlyIndustry.find((temp) => temp.value == item.categoryIndustryId)
						if (!obj) return null

						let sub = item.categoryIds
							.map((subItem) => {
								let tmp = obj.sectors.find((a) => a.value == subItem)
								return tmp
							})
							?.filter((e) => e != null)
						return {
							...item,
							sub,
							text: obj.name,
						}
					})
					?.filter((item) => item !== null) || []
			)
		},
	},
	mounted() {
		this.signupInfo = this.form
	},
	methods: {
		handleShowFieldOfMatchmaking() {
			this.isShowFieldOfMatchmaking = !this.isShowFieldOfMatchmaking
		},
		handleShowMatchmakingHopeActivities() {
			this.isShowMatchmakingHopeActivities = !this.isShowMatchmakingHopeActivities
		},

		addRowDate() {
			this.signupInfo.careers.push({
				careerPeriodFrom: '',
				careerPeriodTo: '',
				name: '',
				inOffice: 0,
			})
		},
		removeRowDate(index) {
			this.signupInfo.careers.splice(index, 1)
		},
	},
	watch: {
		formData: {
			handler(val) {
				this.$emit('update', val)
			},
			deep: true,
		},
	},
}
</script>

<style scoped lang="scss">
.rowTime ::v-deep {
	@import '~bootstrap/dist/css/bootstrap.min';
}

.checkBoxForm ::v-deep {
	@import '~bootstrap/dist/css/bootstrap.min';
	@import '~bootstrap-vue/dist/bootstrap-vue.min';
}

.bspRadio ::v-deep {
	@import '~bootstrap/dist/css/bootstrap.min';
}

.bspSelectBox ::v-deep {
	@import '~bootstrap/dist/css/bootstrap.min';
	@import '~bootstrap-vue/dist/bootstrap-vue.min';
}
</style>

<style scoped lang="css">
.pa-2 {
	padding: 2rem;
}

.article {
	position: relative;
	margin-bottom: 56px;
}

.article::after {
	position: absolute;
	content: '';
	bottom: -14px;
	left: 0;
	width: 100%;
	height: 1px;
	background: #e7e7e7;
}

.textAreaBox {
	width: 100%;
	margin-bottom: 32px;
}

.textAreaBox p {
	display: none;
}

.middle-title {
	margin-bottom: 24px;
}

.textAreaBox textarea {
	width: 100%;
	background: #fdfcfc;
	border: 1px solid #e7e7e7;
	font-size: 20px;
	color: #000000;
	padding: 10px;
	min-height: 80px;
	resize: none;
	overflow: auto;
	font-family: 'Noto Sans KR';
	font-weight: 500;
}

.article-title {
	padding-bottom: 24px;
}

.select-content {
	width: 100%;
}

.select-content > div {
	margin: 18px 0;
}

.checkBoxItem {
	display: flex;
	align-items: center;
}

.checkBoxItem label {
	font-size: 20px;
	margin-left: 12px;
}

.checkBoxItem input {
	width: 22px;
	height: 22px;
}

.checkBoxItem ~ div > select {
	width: 100%;
	height: 45px;
	border: 1px solid #272727;
	font-size: 20px;
	color: #7d7d7d;
	font-weight: 500;
	margin: 13px 0 6px;
}

.btn-outlined {
	width: 120px;
	height: 38px;
	background-color: #fff !important;
	font-size: 1.6rem !important;
	outline: none !important;
	border: 1px solid #969696 !important;
	border-radius: 6px !important;
	color: #444444 !important;
	cursor: pointer;
}
</style>
